// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__TPuNn","avatar":"style_avatar__26qCc","menuIcon":"style_menuIcon__3C25h","usernameStyle":"style_usernameStyle__3-3F-"};